export * from './app.component';
export * from './app.module';



// WEBPACK FOOTER //
// /Users/jonshilton/Projects/nick-smith-app/src/app/index.ts